module.exports = __webpack_public_path__ + "img/MF.4e8e3ba5.jpg";